import { strict } from 'assert';

import type { SanityFormSelect } from '#/lib/sanity/queries/form';
import type { SanityFormConfirmation } from '#/lib/sanity/queries/formConfirmation';

import { FormCustomEnriched } from './Enriched';
import { FormCustomMultiStep } from './MultiStepForm';
import { FormCustomSingle } from './SingleForm';

type Props = {
  form: SanityFormSelect;
  confirmation: SanityFormConfirmation;
  onSubmitSuccess?: () => void;
  onSubmitError?: () => void;
  className?: string;
};

export function FormCustom(props: Props) {
  strict(process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY);

  if (props.form.formType === 'default') {
    return (
      <FormCustomSingle
        className={props.className}
        form={props.form}
        confirmation={props.confirmation}
        onSubmitSuccess={props.onSubmitSuccess}
        onSubmitError={props.onSubmitError}
      />
    );
  }

  if (props.form.formType === 'multistep') {
    return (
      <FormCustomMultiStep
        className={props.className}
        form={props.form}
        confirmation={props.confirmation}
        onSubmitSuccess={props.onSubmitSuccess}
        onSubmitError={props.onSubmitError}
      />
    );
  }

  if (props.form.formType === 'enriched') {
    return (
      <FormCustomEnriched
        className={props.className}
        form={props.form}
        confirmation={props.confirmation}
        onSubmitSuccess={props.onSubmitSuccess}
        onSubmitError={props.onSubmitError}
      />
    );
  }
}
